import React from "react";
import { Stack } from "@mui/material";

export default function NoRowsInDataGrid() {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      Sin información
    </Stack>
  );
}
